import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useState } from 'react';
import { MultiSelect } from "react-multi-select-component";

import ArrowDown from '../../images/icons/arrow.svg';
import ArrowDownBlack from '../../images/icons/arrow-black.svg';

const getWinWidth = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth;
  }
  return 1025
}

const Sorting = ({ handleOrderChange }) => {
  const { t } = useTranslation();
  return (
    <div className="text-lg">
      <span className="hidden lg:block mr-4 text-black">{t('general.sort')}</span>
      <select className="hidden lg:block text-primary font-light bg-transparent" onChange={handleOrderChange}>
        <option value="null">{t('general.sort.relevance')}</option>
        <option value="price_asc">{t('general.sort.priceAsc')}</option>
        <option value="price_desc">{t('general.sort.priceDesc')}</option>
        <option value="createdAt_desc">{t('general.sort.newest')}</option>
      </select>
      <div className="flex lg:hidden items-center">
        <ArrowDown className="fill-primary h-2 -mr-3" />
        <select className="p-0 pl-6 border-0 text-primary font-light bg-transparent appearance-none w-24" onChange={handleOrderChange}>
          <option disabled selected>{t('general.sort')}</option>
          <option value="null">{t('general.sort.relevance')}</option>
          <option value="price_asc">{t('general.sort.priceAsc')}</option>
          <option value="price_desc">{t('general.sort.priceDesc')}</option>
          <option value="createdAt_desc">{t('general.sort.newest')}</option>
        </select>
      </div>
    </div>
  )
}

const AbstractFilter = ({
  title,
  filterValues,
  handleFilterChange,
  finalFilterData,
  wrapperClasses = ''
}) => {
  const [isOpen, setIsOpen] = useState(getWinWidth() > 1024);

  return (
    <div className="p-4 border border-x-0 border-t-0 border-primary lg:border-0">
      <button className="text-primary lg:text-black lg:font-bold border-0 outline-0" onClick={() => setIsOpen(!isOpen)}>{title}</button>
      <div className={`flex-col h-auto overflow-y-hidden flex-wrap ${isOpen ? 'flex' : 'hidden'} ${wrapperClasses}`}>
        {filterValues.map(v => (
          <div key={`filter-${v.id ? v.id : v.name}`} className="my-2 mr-2 flex items-center">
            <input type="checkbox" id={v.id ? v.id : v} onChange={handleFilterChange} checked={finalFilterData.includes(v.id ? v.id : v)} />
            <label htmlFor={v.id ? v.id : v}>{v.name ? v.name : v}</label>
          </div>
        ))}
      </div>
    </div>
  )
}

const ModelFilter = ({
  handleModelChange,
  filterModels,
  selectOptions
}) => {
  const { t } = useTranslation();
  return (
    <div className="p-4">
      <b className="font-light text-primary lg:text-black lg:font-bold">{t('general.model')}</b>
      <div className="flex flex-col flex-wrap mt-4 lg:mt-0">
        <MultiSelect
          options={selectOptions}
          value={filterModels.map(model => ({ label: model, value: model }))}
          onChange={handleModelChange}
          labelledBy="Select"
        />
      </div>
    </div>
  )
}

const Filters = ({
  paginationTopScrollRef,
  handleOrderChange,
  brand,
  brands,
  filterBrands,
  handleBrandChange,
  watchConditions,
  filterConditions,
  handleConditionChange,
  genders,
  filterGenders,
  handleGenderChange,
  movements,
  filterMovements,
  handleMovementChange,
  models,
  filterModels,
  handleModelChange
}) => {
  const { t } = useTranslation();
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  const selectOptions = models.distinct.map(model => ({
    label: model,
    value: model,
  }));

  return (
    <details className="flex flex-col w-full mb-8 lg:mb-14 border border-b-0 border-x-0 px-5 pt-4 pb-6" ref={paginationTopScrollRef} open={isFiltersOpen}>
      <summary className="text-xl text-primary flex items-center justify-between w-full">
        <button className="flex items-center text-lg lg:text-xl border-0 outline-0" onClick={() => setIsFiltersOpen(!isFiltersOpen)}>
          <ArrowDown className={`transition-all duration-100 h-2 lg:h-3 mr-4 ${isFiltersOpen ? 'rotate-180' : ''}`} />
          {t('buyingHero.filter')}
        </button>
        <Sorting handleOrderChange={handleOrderChange} />
      </summary>
      <div
        className="lg:my-4 p-4 lg:p-0 fixed top-0 left-0 bottom-0 right-0 overflow-y-auto w-screen min-h-screen lg:w-auto lg:min-h-full bg-gray z-50 lg:bg-transparent lg:static lg:grid lg:grid-cols-4 xl:grid-cols-5"
      >
        <div className="lg:hidden border border-primary border-t-0 border-x-0 p-4 pb-6 flex justify-between">
          <span className="font-cirka text-xl">{t('buyingHero.filter')}</span>
          <button onClick={() => setIsFiltersOpen(!isFiltersOpen)} className="border-0 outline-0">
            <ArrowDownBlack className="transition-all duration-100 h-2 lg:h-3 mr-4 rotate-180" />
          </button>
        </div>
        {brand ? null : <AbstractFilter title={t('general.brand')} filterValues={brands.distinct} handleFilterChange={handleBrandChange} finalFilterData={filterBrands} wrapperClasses="!grid lg:grid-cols-1 grid-cols-2" />}
        <AbstractFilter title={t('general.watchCondition')} filterValues={watchConditions} handleFilterChange={handleConditionChange} finalFilterData={filterConditions} />
        <AbstractFilter title={t('general.gender')} filterValues={genders} handleFilterChange={handleGenderChange} finalFilterData={filterGenders} />
        <AbstractFilter title={t('general.movement')} filterValues={movements} handleFilterChange={handleMovementChange} finalFilterData={filterMovements} />
        <ModelFilter filterModels={filterModels} handleModelChange={handleModelChange} selectOptions={selectOptions} />
      </div>
    </details>
  )
}

export default Filters;
